import { render } from "./index.vue?vue&type=template&id=3bfaa4e6"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/featuresZeroNav/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3bfaa4e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3bfaa4e6', __exports__)) {
    api.reload('3bfaa4e6', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=3bfaa4e6", () => {
    api.rerender('3bfaa4e6', render)
  })

}


export default __exports__